// Not used
const simulationToProposalForm = (data, { value: entityId, text: entityValue, address: entityAddress }, userName, bmDropdownValues) => {
    const { businessManagerEmail, businessManagerPhone, idBusinessManager } = bmDropdownValues.find((value) => value.text === userName);
    const { clientInfo, financingInfo, vehicleInfo, simulationResults } = data;
    const carMonth = vehicleInfo.plateMonth.text.length === 1 ? "0" + vehicleInfo.plateMonth.text : vehicleInfo.plateMonth.text;
    const carYear = vehicleInfo.plateYear.text;
    const carDtPlate = vehicleInfo.vehicleCondition?.id === 1
        ? ""
        : carYear + "-" + carMonth + "-" + "01";
    const transformationObject = {
        "lstParticipants": [
            {
                "participant": {
                    "BI": "",
                    "CAE": "",
                    "DTHiredText": "",
                    "DTStartEniActivityText": "",
                    "GDPRAccessGovernmentData": "N",
                    "GDPRSendInfoProducts": "N",
                    "ID": 252844,
                    "NIF": "",
                    "NISS": "",
                    "address1SameAddress2": true,
                    "antePenultimateYear": 0,
                    "beneficialOwner": "",
                    "birthdateText": clientInfo?.birthdate,
                    "checkDigitBI": " ",
                    "checkDigitOtherBI": "",
                    "companyActivity": "",
                    "companyAddress": "",
                    "companyCAE": "",
                    "companyCity": "",
                    "companyNIF": "",
                    "companyName": "",
                    "companyNrEmployees": 0,
                    "companyPhone": "",
                    "companyPostalCode1": "",
                    "companyPostalCode2": "",
                    "contractHolder": "N",
                    "corporateName": "",
                    "countryBI": "",
                    "createdBy": "307473708||ommo",
                    "dtCreated": "2022-11-24T11:33:32Z[UTC]",
                    "dtEmissionCCText": "",
                    "dtExpireCCText": "",
                    "dtExpirePassportText": "",
                    "dtExpireResidenceAuthorizationText": "",
                    "email": clientInfo?.email,
                    "emissionEntityCC": "",
                    "fax": "",
                    "gender": "",
                    "idAddress1": 0,
                    "idAddress2": 0,
                    "idPersonProfit": 0,
                    "idPublicPosition": 0,
                    "job": "",
                    "lastYear": 0,
                    "legalFormCompany": "",
                    "legalPersonNif": "",
                    "maritalState": "",
                    "marriageType": "",
                    "name": clientInfo?.name,
                    "nationality": "",
                    "naturalityDistrict": "",
                    "naturalityMunicipality": "",
                    "naturalityParish": "",
                    "nrDependents": 0,
                    "obs": "",
                    "otherBI": "",
                    "otherNationalities": "",
                    "penultimateYear": 0,
                    "personPendingFinancingFirst": {
                        "financialName": "",
                        "id": 0,
                        "idPerson": 0,
                        "installmentValue": 0,
                        "liquidateValue": 0,
                        "position": 0
                    },
                    "personPendingFinancingSecound": {
                        "financialName": "",
                        "id": 0,
                        "idPerson": 0,
                        "installmentValue": 0,
                        "liquidateValue": 0,
                        "position": 0
                    },
                    "personPendingFinancingThird": {
                        "financialName": "",
                        "id": 0,
                        "idPerson": 0,
                        "installmentValue": 0,
                        "liquidateValue": 0,
                        "position": 0
                    },
                    "phone1": clientInfo?.phoneNumber,
                    "phone2": "",
                    "principalActivityCountry": "",
                    "professionalCategory": "",
                    "professionalStatus": "",
                    "refusedDeliveryDocumentation": "N",
                    "relationToProponent": "",
                    "socialObject": ""
                },
                "position": 1,
                "type": "Titular"
            }
        ],
        "proposal": {
            "bank": {
                "NIB": "",
                "accountAge": "",
                "accountNumber": "",
                "name": "",
                "outlet": ""
            },
            "carData": {
                "carBrand": vehicleInfo.brand,
                "carCategory": vehicleInfo.vehicleType,
                "carChassis": "",
                "carDisplacement": vehicleInfo.displacementEngine,
                "carFuelType": vehicleInfo.fuel,
                "carGrossweight": vehicleInfo.grossWeight,
                "carHp": vehicleInfo.enginePower,
                "carKms": 0,
                "carModel": vehicleInfo.model,
                "carDtPlate": carDtPlate,
                "carMonth": Number(vehicleInfo.plateMonth.text),
                "carYear": Number(vehicleInfo.plateYear.text),
                "carNrDoors": vehicleInfo.doors,
                "carPlate": "",
                "carSeats": vehicleInfo.places,
                "carTylacode": vehicleInfo.euroTaxCode,
                "carType": vehicleInfo.vehicleCondition?.id === 1
                    ? "Novo"
                    : "Usado",
                "carVersion": vehicleInfo.version
            },
            "createdBy": "",
            "customerType": clientInfo?.clientTypeLabel,
            "debitNoteNumber": "",
            "dtCreated": "",
            "financialContractCode": "",
            "financialData": {
                "capitalToFinance": Number(simulationResults.capitalToFinance),
                "differentialFeeNrMonths": 0,
                "differentialFeeValue": 0,
                "expensesClient": Number(simulationResults?.initialExpenses),
                "expensesFinance": financingInfo?.withFinancedExpenses.id === 1
                    ? "S"
                    : "N",
                "feeWithoutInsurenceClient": Number(
                    simulationResults?.feeWithoutInsurence
                ),
                "firstPayment": Number(simulationResults?.firstPayment),
                "guarantee": Number(simulationResults?.guarantee),
                "idProduct": Number(financingInfo.selectedProd?.value),
                "initialEntrance": Number(financingInfo?.initialEntry),
                "insurancePPCName": financingInfo.ppcValue.value === -1 ? "" : financingInfo.ppcValue.text,
                "insurancePPCNrInsuredPeople": Number(
                    financingInfo.ppcNrValue?.text
                ),
                "insurancePPCValueClient": Number(simulationResults?.singlePPCValue),
                "lackPeriod": 0,
                "maintenanceContract": 0,
                "obs": "",
                "period": Number(financingInfo?.period),
                "periodicity": financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
                "portsExpenses": Number(simulationResults?.portsExpenses),
                "price": Number(financingInfo?.pvp),
                "productName": financingInfo.selectedProd?.text,
                //TODO: Verificar IVA
                "purchaseIVA": 23,
                "rateClient": Number(financingInfo?.rate),
                "rateType": financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
                "residualValue": financingInfo?.residualValue === ""
                    ? 0
                    : Number(financingInfo?.residualValue),
                //TODO: Verificar estes dados
                "rewardClient": {
                    "PPCInsurance": 364.05,
                    "expenses": 200,
                    "financial": 512.29,
                    "financialDealer": 512.29,
                    "incrementalMonth1": 0,
                    "incrementalMonth2": 0
                },
                //TODO: Verificar IVA
                "salesIVA": 23,
                "specialRequest": false,
                "taeg": Number(simulationResults?.taeg),
                "taxStamp": Number(simulationResults?.taxStamp),
                "taxstampFinance": financingInfo?.withFinancedTax.id === 1
                    ? "S"
                    : "N",
                "warrantyExtra": 0
            },
            "id": 203702,
            "idFinancial": Number(financingInfo.selectedFin?.value),
            "idSource": 0,
            "identification": {
                "GSCCode": "1669289611995",
                "financialCode": "",
                "originalGSCCode": "1669289611995"
            },
            "lastIdState": 0,
            "lstparticipantPosition": [
                {
                    "ENIType": "",
                    "changedBy": "307473708||ommo",
                    "createdBy": "307473708||ommo",
                    "dtChanged": "2022-11-24T11:33:32Z[UTC]",
                    "dtCreated": "2022-11-24T11:33:32Z[UTC]",
                    "id": 286554,
                    "idClienttype": 1,
                    "idCompany": 0,
                    "idPerson": 252844,
                    "idProposal": 203702,
                    "interventionType": "Titular",
                    "position": 1
                }
            ],
            "propAnswer": {
                "financialCode": "",
                "gscCode": "",
                "id": 0,
                "idFinancial": 0,
                "idProposal": 0,
                "riskApprovalReason": "",
                "riskApprovalStatus": "",
                "technicalApprovalReason": "",
                "technicalApprovalStatus": ""
            },
            "proposalType": "Proposta",
            "salesPoint": {
                "businessManagerEmail": businessManagerEmail,
                "businessManagerName": userName,
                "businessManagerPhone": businessManagerPhone,
                "canvasserEntityAddress": entityAddress,
                "canvasserEntityName": entityValue,
                "canvasserIdEntity": entityId,
                "idBusinessManager": idBusinessManager,
                "salesman": clientInfo.seller,
                "supplierEntityAddress": "",
                "supplierEntityName": "",
                "supplierIdEntity": null,
            }
        }
    }

    return transformationObject;
};

export { simulationToProposalForm };